import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { MeilleursBiensService } from 'app/services/meilleuresBiens/meilleurs-biens.service';
import { SearchService } from 'app/services/search/search.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-cafe-resto-sousse',
  templateUrl: './cafe-resto-sousse.component.html',
  styleUrls: ['./cafe-resto-sousse.component.scss']
})
export class CafeRestoSousseComponent implements OnInit {


  public cafeSousse: any
  p: Number = 1;
  closeResult = '';
  public agencies: any
  search_name1: any;
  dataSource = new MatTableDataSource();
  public search: string = ''

  constructor(private agenciesService: AgenciesService,

    private searchService: SearchService) { }
  ngOnInit(): void {
    this.cafeeSousse();

  }
  // cafeeSousse() {
  //   this.agenciesService.getList().subscribe((data: any) => {
  //     this.cafeSousse = data;
  //     console.log('old data ', this.cafeSousse);

  //     this.agencies = this.cafeSousse.filter((agency: any) => {
  //       return agency.region === 'sousse' && agency.phone_number_commercial === 'yes';
  //     });

  //     console.log('Filtered agencies from Tunis with phone_number_commercial: "yes"', this.agencies);


  //   });
  // }
  cafeeSousse() {

    this.agenciesService.getList().subscribe((data: any) => {
      this.cafeSousse = data
      this.agencies = this.cafeSousse.filter((agency: any) => {
        return agency.region === 'sousse' && agency.phone_number_commercial === 'yes'
      })
      console.log(this.cafeSousse);
    })
  }




  // SupprimerMeilleursBiens(MeilleursBiens: any) {
  //   this.meilleursBiensService.deleteMeilleursBiens(MeilleursBiens.id).subscribe((response: any) => {


     


  //   });


  // }
  // Méthode pour effectuer la recherche
  performSearch() {
    this.cafeSousse = this.searchService.search(this.cafeSousse, this.search);
  }
  deleteAgencies(agencie, i) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.agenciesService.deleteItem(agencie.id).subscribe((response: any) => {
          console.log(this.dataSource.data);
          this.cafeSousse.splice(i, 1)

          // If you want to show a success message after the deletion, use another Swal.fire here
          Swal.fire({
            title: "Supprimé!",
            text: "Votre agence a été supprimée.",
            icon: "success"
          });
          // Fetch the updated data after deletion
          // setTimeout(() => {
          //   this.getagencesTunis();
          // }, 500);

        });
      }
    });
  }
}
